import { Theme as AugmentedTheme, useTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { Icon, IconName, Button, summonDownload } from 'web-library';
import { useDownloadDataArchivalReport } from '../../../../api-refactored/data-archival-report/useDownloadDataArchivalReport';

const useStyles = makeStyles()((theme) =>
({
  downloadPdfText: {
    fontWeight: 800,
    paddingLeft: theme.spacing(1),
  },
}));

interface DataArchivalReportDownloadLinkProps {
  fileUuid: string;
}

const DataArchivalReportDownloadLink = ({ fileUuid }: DataArchivalReportDownloadLinkProps) => {
  const { classes } = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();

  const { mutate: downloadDataArchivalReport } = useDownloadDataArchivalReport({
    onSuccess: (res) => {
      if (res.url) summonDownload(res.url);
    },
  });

  return (
    <Button
      // noWrap
      variant='text'
      className={classes.downloadPdfText}
      onClick={() =>
        downloadDataArchivalReport({
          uuid: fileUuid,
          contentDisposition: 'INLINE',
        })
      }
    >
      <Icon name={IconName.download} size="M" color={theme.color.link.linkDefault01} />
      <span className={classes.downloadPdfText}>{t('admin->>DataArchivalReport.Download')}</span>
    </Button>
  );
};

export default DataArchivalReportDownloadLink;
